import { Helmet } from "react-helmet";
import { ScriberXHero } from "./NEW-WEB-DESIGN-TEMP/index";

export const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Scriber O – AI's missing human input</title>
        <meta
          name="description"
          content="Scriber O turns physiological context into AI input, so your body can speak before words."
        />
        <meta property="og:title" content="Scriber O – AI's missing human input" />
        <meta
          property="og:description"
          content="Scriber O turns physiological context into AI input, so your body can speak before words."
        />
        <meta property="og:url" content="https://mindscriber.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://mindscriber.com/images/mindscriber-logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@MindScriber" />
        <meta name="twitter:title" content="Scriber O – AI's missing human input" />
        <meta
          name="twitter:description"
          content="Scriber O turns physiological context into AI input, so your body can speak before words."
        />
        <meta
          name="twitter:image"
          content="https://mindscriber.com/images/mindscriber-logo.png"
        />
      </Helmet>
      <ScriberXHero />
    </>
  );
};
